export function ServiceContractTypeFactory() {
    return function ServiceContractType() {
        this.id = null;
        this.code = null;
        this.name = null;
    };
}
